// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  padding: 1.75rem 0 2.25rem;
  border-top: 1px solid var(--line);
  background: rgba(15, 46, 36, 0.03);
}

.footer__inner {
  width: var(--wide);
  margin: 0 auto;
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 1.5rem;
}

.footer__logo {
  display: inline-flex;
  margin-bottom: 0.55rem;
}

.footer__brand p {
  color: var(--muted);
  font-size: 0.95rem;
}

.footer__meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.45rem;
  color: var(--muted);
  font-size: 0.92rem;
}

.footer__meta a {
  font-weight: 600;
  color: var(--ink);
}

.footer__meta a:hover {
  color: var(--moss);
}

.footer__links {
  display: flex;
  gap: 1rem;
}

.footer__links a {
  font-weight: 500;
  color: var(--muted);
}

@media (max-width: 640px) {
  .footer__inner {
    flex-direction: column;
    align-items: flex-start;
  }

  .footer__meta {
    align-items: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".footer {\r\n  padding: 1.75rem 0 2.25rem;\r\n  border-top: 1px solid var(--line);\r\n  background: rgba(15, 46, 36, 0.03);\r\n}\r\n\r\n.footer__inner {\r\n  width: var(--wide);\r\n  margin: 0 auto;\r\n  display: flex;\r\n  align-items: end;\r\n  justify-content: space-between;\r\n  gap: 1.5rem;\r\n}\r\n\r\n.footer__logo {\r\n  display: inline-flex;\r\n  margin-bottom: 0.55rem;\r\n}\r\n\r\n.footer__brand p {\r\n  color: var(--muted);\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.footer__meta {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-end;\r\n  gap: 0.45rem;\r\n  color: var(--muted);\r\n  font-size: 0.92rem;\r\n}\r\n\r\n.footer__meta a {\r\n  font-weight: 600;\r\n  color: var(--ink);\r\n}\r\n\r\n.footer__meta a:hover {\r\n  color: var(--moss);\r\n}\r\n\r\n.footer__links {\r\n  display: flex;\r\n  gap: 1rem;\r\n}\r\n\r\n.footer__links a {\r\n  font-weight: 500;\r\n  color: var(--muted);\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .footer__inner {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .footer__meta {\r\n    align-items: flex-start;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
